<style lang="sass">

    @import ../../common/styles/settings
    @import ../../common/styles/mixins
    @import page-always

</style>

<script>

    import $ from 'jquery'

    import Locator from '../../common/components/locator/Locator.vue'
    import Newsfeed from '../../common/components/Newsfeed.vue'

    export default {
        components: {
            Locator,
            Newsfeed
        },
        data() {
            return {
                isMobile: false,
            }
        },
        mounted () {
            this.isMobile = document.documentElement.clientWidth < 769
            setTimeout(() => this.setSticky() , 110)
        },
        methods: {
           setSticky() {

                const mobileGap = 55
                const ratioSpace = this.isMobile ? 1 : 3.5

                let $el = $(this.$el)
                let $localHeader = $(this.$refs.header)
                let $localContent = $(this.$refs.content)
                let $cta = $localHeader.find('.page__header__cta')

                let baseline = parseInt(window.getComputedStyle(document.body).getPropertyValue('font-size'))
                let localHeaderHeight = $localHeader.height()
                let navHeight = $('.region-header').height() + (this.isMobile ? $('.region-header').height() : $('.region-navigation').height())

                let offset = localHeaderHeight - ($cta.height() + (baseline*ratioSpace))

                if(this.isMobile)
                    offset += mobileGap

                const headerScroll = () => {

                    let st = $(window).scrollTop()
                    let deltaScroll = offset - st

                    if ( deltaScroll  <= 0 ) {
                        $el.addClass('page-always--sticky')
                        $localHeader.css({ top: (navHeight - offset) + 'px' })
                        $localContent.css({ marginTop: (localHeaderHeight) + 'px' })
                    }  else {
                        $el.removeClass('page-always--sticky')
                        $localHeader.removeAttr('style')
                        $localContent.removeAttr('style')
                    }

                }

                window.addEventListener('scroll', headerScroll)
            }
        }
    }

</script>

<script setup>
import Locator from '../../common/components/locator/Locator.vue'
import Newsfeed from '../../common/components/Newsfeed.vue'
import { onMounted, ref } from 'vue'

const isMobile = ref(false)

onMounted(() => {
  isMobile = document.documentElement.clientWidth < 769
  setTimeout(() => setSticky() , 110)
})

function setSticky() {

  const mobileGap = 55
  const ratioSpace = this.isMobile ? 1 : 3.5

  let $el = $(this.$el)
  let $localHeader = $(this.$refs.header)
  let $localContent = $(this.$refs.content)
  let $cta = $localHeader.find('.page__header__cta')

  let baseline = parseInt(window.getComputedStyle(document.body).getPropertyValue('font-size'))
  let localHeaderHeight = $localHeader.height()
  let navHeight = $('.region-header').height() + (this.isMobile ? $('.region-header').height() : $('.region-navigation').height())

  let offset = localHeaderHeight - ($cta.height() + (baseline*ratioSpace))

  if(isMobile)
      offset += mobileGap

  const headerScroll = () => {

      let st = $(window).scrollTop()
      let deltaScroll = offset - st

      if ( deltaScroll  <= 0 ) {
          $el.addClass('page-always--sticky')
          $localHeader.css({ top: (navHeight - offset) + 'px' })
          $localContent.css({ marginTop: (localHeaderHeight) + 'px' })
      }  else {
          $el.removeClass('page-always--sticky')
          $localHeader.removeAttr('style')
          $localContent.removeAttr('style')
      }

  }

  window.addEventListener('scroll', headerScroll)
  }
</script>
